'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import Button from '@/components/ui/Button';
import { getAccessToken } from '@/lib/authStorage';

// Комментарий на русском: версия согласия. Зачем: после обновления документа показываем баннер всем снова.
const COOKIE_NAME = 'privacy_policy_v2026_01_03';

function getCookie(name: string) {
  const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`));
  return m?.[1] ? decodeURIComponent(m[1]) : '';
}

function setCookie(name: string, value: string, maxAgeSec: number) {
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAgeSec}; SameSite=Lax`;
}

export default function LicenseAgreementBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Комментарий на русском: показываем только гостям и только если cookie ещё не установлена.
    if (getAccessToken()) return;
    if (!getCookie(COOKIE_NAME)) setOpen(true);
  }, []);

  if (!open) return null;

  const choose = (value: '1' | '0') => {
    setCookie(COOKIE_NAME, value, 60 * 60 * 24 * 365);
    setOpen(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[90] border-t border-site-border bg-site-bg/70 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <div className="text-sm text-site-text">
          Для использования сайта необходимо принять{' '}
          <Link prefetch={false} href="/privacy" className="text-site-accent hover:text-site-accent underline underline-offset-4">
            Политику обработки персональных данных
          </Link>
          .
        </div>
        <div className="flex gap-2 w-full sm:w-auto sm:ml-auto">
          <Button variant="outline" size="sm" className="flex-1 sm:flex-none" onClick={() => choose('0')}>
            Отклонить
          </Button>
          <Button variant="primary" size="sm" className="flex-1 sm:flex-none" onClick={() => choose('1')}>
            Принять
          </Button>
        </div>
      </div>
    </div>
  );
}


